import { render } from "./transferRequests.vue?vue&type=template&id=c4c0cd52&scoped=true&ts=true"
import script from "./transferRequests.vue?vue&type=script&lang=ts"
export * from "./transferRequests.vue?vue&type=script&lang=ts"

import "./transferRequests.vue?vue&type=style&index=0&id=c4c0cd52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4c0cd52"]])

export default __exports__